module.exports = __webpack_public_path__ + "media/images/sandbox/note_paper_opt-983287a3e306f6afbcd5e70885200c34.png";